import { PSTFieldNames } from '@common/data-models/fields/pst-field-names';
import { ViewStateSequence } from '@common/data-models/navigation/viewstate-sequence';
import { ViewStateOptionsSerializer } from '@common/data-models/serializers/serializers';
import { ViewStateTypes } from '@common/enums/viewstate-types';

import { Record } from './record';
import { SingleFeedViewStateRecord } from './single-feed-viewstate-record';
import { ViewStateRecord } from './viewstate-record';

export class MultipleFeedViewStateRecord extends SingleFeedViewStateRecord {
    public initialize() {
        super.initialize();
        this.viewStateType = ViewStateTypes.MULTIPLEFEED;
        this.viewStateLayout = ViewStateOptionsSerializer.Instance(Record.globalTablesService).initialize(this.viewStateType, PSTFieldNames.PSTViewStateLayout);
        this.viewStateSequence = new ViewStateSequence();
    }

    public get viewStateSequence(): ViewStateSequence {
        return this.getAs<ViewStateSequence>('PSTViewStateSequence');
    }
    public set viewStateSequence(value: ViewStateSequence) {
        this.set('PSTViewStateSequence', value);
    }

    public get viewStates(): Array<ViewStateRecord> {
        return this.getAs<Array<ViewStateRecord>>('PSTMultiFeedViewStates');
    }
    public set viewStates(value: Array<ViewStateRecord>) {
        this.set('PSTMultiFeedViewStates', value);
    }
}
